import useBlProviders from '../providers/useBlProvider'
import WorksDt from '@/services/dataTransferModules/worksDt'

export default function useWorks() {
	const workDt = new WorksDt()

	const {
		loadEntityFlags: flags,

		entities: works,
		getEntities: getWorks,

		hashedEntities: hashedWorks,
		getHashedEntities: getHashedWorks,

		extendedEntities: extendedWorks,
		getExtendedEntities: getExtendedWorks,

		basedEntities: basedWorks,
		getBasedEntities: getBasedWorks,

		createEntity: createWork,

		entity: work,
		getEntity: getWork,

		patchEntity: patchWork,

		deleteEntity: deleteWork,
	} = useBlProviders(workDt)

	const defaults = {
		creatingWork: {
			work_type: '',
			name: '',
			category: '',
		},
		fieldsToPatch: ['work_type', 'name', 'category'],
	}

	return {
		flags,
		basedWorks,
		extendedWorks,
		works,
		work,
		defaults,

		getBasedWorks,
		getExtendedWorks,
		getWorks,
		getWork,
		createWork,
		patchWork,
		deleteWork,

		hashedWorks,
		getHashedWorks,
	}
}
